import { ReferralDetails } from "@features/admin/users/api";
import { fetchData, PaginationParameters, PaginationResponse } from "@request";
import { getQueryParams } from "@request/helpers";

export type LeadBalance = {
  amount: number;
  pay_in: number;
  pay_out: number;
};

export const getLeadBalancesApi = async (userId: string) => {
  try {
    const response = await fetchData<LeadBalance>({
      url: `api/v1/users/ref-ern-balances/${userId}`,
    });
    return response;
  } catch (error) {
    console.error("getLeadBalancesApi failed:", error);
    throw error;
  }
};

export type LeadEarnData = {
  team_lead_commission_pay_in: number;
  team_lead_commission_pay_out: number;
  total_pay_in_usdt: number;
  total_pay_out_usdt: number;
  total_usdt: number;
  referral_details: ReferralDetails[];
};

export const getLeadPartnersApi = async (userId: string) => {
  try {
    const response = await fetchData<LeadEarnData>({
      url: `api/v1/users/ern-data/${userId}`,
    });
    return response;
  } catch (error) {
    console.error("getLeadPartners failed:", error);
    throw error;
  }
};

export type LeadOrders = {
  created_at: string;
  created_at_unix: number;
  earnings: number;
  method: string;
  operation: string;
  order_amount: number;
  order_amount_usdt: number;
  order_uuid: string;
  referral_email: string;
  status: string;
};

export type LeadOrdersResponse = PaginationResponse<{ orders: LeadOrders[] }>;

export const getRefOrdersApi = async (userId: string, data: PaginationParameters) => {
  try {
    const query = getQueryParams(data);
    const response = await fetchData<LeadOrdersResponse>({
      url: `api/v1/users/ref-orders/${userId}?${query}`,
    });
    return response;
  } catch (error) {
    console.error("getRefOrdersApi failed:", error);
    throw error;
  }
};
